<template>
  <div class="social-links d-flex flex-column">
    <div
      class="font-weight-bold text-center fs-14 fs-md-16 social-links__text"
    >
      {{ $t('signIn.spreadTheWord') }}
    </div>

    <div class="d-flex justify-center mt-4">
      <a
        class="social-links__link mr-3"
        href="https://www.facebook.com/secureship/"
        target="_blank"
        title="Facebook"
      >
        <v-icon>mdi-facebook</v-icon>
      </a>
      <a
        class="social-links__link mr-3"
        href="https://twitter.com/Secureship"
        target="_blank"
        title="X (Twitter)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          style="width: 24px; height: 24px;"
          aria-hidden="true"
        >
          <path d="M 2.3671875 3 L 9.4628906 13.140625 L 2.7402344 21 L 5.3808594
            21 L 10.644531 14.830078 L 14.960938 21 L 21.871094 21 L
            14.449219 10.375 L 20.740234 3 L 18.140625 3 L 13.271484 8.6875
            L 9.2988281 3 L 2.3671875 3 z M 6.2070312 5 L 8.2558594 5 L
            18.033203 19 L 16.001953 19 L 6.2070312 5 z" fill="currentColor"/>
        </svg>
      </a>
      <a
        class="social-links__link"
        href="https://www.linkedin.com/company/secureship"
        target="_blank"
        title="LinkedIn"
      >
        <v-icon>mdi-linkedin</v-icon>
      </a>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SocialLinks extends Vue {}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/include-media.scss';

.social-links {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__link {
    text-decoration: none;

    i {
      color: $color-primary;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  &__text {
    @include media('<tablet') {
      max-width: 215px;
    }
  }
}
</style>
